import { atom } from "jotai";
import type {
    LocationStatusCounts,
    OrganizationDetail,
    OrganizationResponse,
    PaginatedOrganizations,
} from "@models/organization";

export const organizationsAtom = atom<OrganizationResponse[]>([]);

export const isProcessingOrganizationsAtom = atom<boolean>(false);

// --- Admin clients list (E5-S7 / US 194) ---------------------------------
// Paginated org list from GET /organizations. Kept separate from
// `organizationsAtom` (the customer-facing array) so the two flows don't
// fight over one atom.
export const organizationsListAtom = atom<PaginatedOrganizations>({
    pageNumber: 1,
    totalPages: 0,
    count: 0,
    hasPreviousPage: false,
    hasNextPage: false,
    items: [],
});

export const isFetchingOrganizationsListAtom = atom<boolean>(false);

export const organizationDetailAtom = atom<OrganizationDetail | null>(null);

export const isFetchingOrganizationDetailAtom = atom<boolean>(false);

// Per-LOCATION status counts (approval is per-location, DecisionLog §1.2; #332),
// kept independently so the admin top-bar badge can stay populated without
// depending on the Clients page being mounted (and without a header fetch
// clobbering the page's list data).
export const locationStatusCountsAtom = atom<LocationStatusCounts>({
    total: 0,
    pending: 0,
    approved: 0,
    rejected: 0,
    suspended: 0,
    pendingPayment: 0,
});
